import React, { Suspense, lazy } from 'react';

// Lazy load PayPal component to prevent cssRules error on page load
const PayPalCheckout = lazy(() => 
  import('./PayPalCheckout').then(module => ({ default: module.PayPalCheckout }))
);

// Error boundary to catch PayPal SDK errors
class PayPalErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Check if it's the cssRules error we want to ignore
    if (error?.message?.includes('cssRules')) {
      return { hasError: false };
    }
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Suppress cssRules errors
    if (error?.message?.includes('cssRules')) {
      return;
    }
    console.error('PayPal Error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="p-4 bg-red-50 text-red-700 rounded-lg">
          Payment system temporarily unavailable. Please try again later.
        </div>
      );
    }
    return this.props.children;
  }
}

export const PayPalWrapper = (props) => {
  return (
    <PayPalErrorBoundary>
      <Suspense fallback={
        <div className="flex items-center justify-center p-4">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-cafa-red"></div>
          <span className="ml-2 text-stone-600">Loading payment options...</span>
        </div>
      }>
        <PayPalCheckout {...props} />
      </Suspense>
    </PayPalErrorBoundary>
  );
};
